import { intersection, union } from 'lodash';

import { QuickLinkViewItem } from '../models';

const sortSeqItems =
  (fallbackSeq: number) => (a: QuickLinkViewItem, b: QuickLinkViewItem) => {
    const aSeq = a.seq || a.seq === 0 ? a.seq : fallbackSeq;
    const bSeq = b.seq || b.seq === 0 ? b.seq : fallbackSeq;

    return aSeq - bSeq;
  };

export const getQuickLinksOrder = (
  quickLinkViewItems: QuickLinkViewItem[],
  savedQuickLinksOrder: string[],
): string[] => {
  const quickLinkIds = quickLinkViewItems
    .slice()
    .sort(sortSeqItems(quickLinkViewItems.length))
    .map((link) => link.id);

  if (!savedQuickLinksOrder.length) {
    return quickLinkIds;
  }

  return intersection(union(savedQuickLinksOrder, quickLinkIds), quickLinkIds);
};
